<template>
  <div class="company-and-contact-names-cell">
    <div class="company-name" :class="{ 'text-sm': name }">
      {{ companyName }}
    </div>
    <div class="name">
      {{ name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyAndContactNamesCell",
  props: {
    companyName: String,
    name: String
  }
};
</script>
